import { AutocompleteRenderOptionState, Box } from '@mui/material';
import { ChipAutocomplete, ChipAutocompleteProps } from '@synergy/components';
import { Classification } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import { fetchAllClassifications } from '../../../features/configuration/organization/classifications/store/classifications-actions';
import { useAppSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

export type ClassificationAutocompleteProps = Omit<
    ChipAutocompleteProps<Classification>,
    'options' | 'getOptionLabel' | 'getChipLabel' | 'onOpen' | 'renderOption'
>;

export const ClassificationAutocomplete = (props: ClassificationAutocompleteProps) => {
    const dispatch = useThunkDispatch();
    const classifications = useAppSelector(state => state.classifications.classifications.items);

    const renderOption = (item: Classification, state: AutocompleteRenderOptionState) => {
        const nameMatches = match(item.name, state.inputValue);
        const nameParts = parse(item.name, nameMatches);

        return (
            <div>
                {nameParts.map((namePart, index) => (
                    <Box sx={{ display: 'inline', color: namePart.highlight ? 'primary.main' : undefined }} key={index}>
                        {namePart.text}
                    </Box>
                ))}
            </div>
        );
    };

    const handleClassificationsOpen = () => {
        if (classifications.length === 0) {
            dispatch(fetchAllClassifications());
        }
    };

    return (
        <ChipAutocomplete
            {...props}
            noOptionsText={props.noOptionsText ?? <FormattedMessage id="app.common.emptyResult" />}
            options={classifications}
            getOptionLabel={classification => classification.name}
            getChipLabel={classification => classification.name}
            renderOption={renderOption}
            onOpen={handleClassificationsOpen}
            isOptionEqualToValue={(option, value) => option.id === value.id}
        />
    );
};
